import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2767878251/src/app/[locale]/(site)/_components/LandingHomePage.tsx");
